// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import * as PaymentSuccessStore$PorterinFeature from "../store/PaymentSuccessStore.mjs";
import * as DownloadAnalyticsHelper$PorterinFeature from "../../../../../download-app/helpers/DownloadAnalyticsHelper.mjs";
import * as PaymentSuccessMobFooterModuleScss from "../styles/PaymentSuccessMobFooter.module.scss";

var styles = PaymentSuccessMobFooterModuleScss;

function PaymentSuccessMobFooterCmp(Props) {
  return React.createElement("div", {
              className: styles["download-app-footer"]
            }, React.createElement("button", {
                  className: styles.cta
                }, React.createElement(Link, {
                      href: DownloadAnalyticsHelper$PorterinFeature.app_download_link,
                      children: PaymentSuccessStore$PorterinFeature.downloadNow
                    })));
}

var Link$1;

var make = PaymentSuccessMobFooterCmp;

export {
  Link$1 as Link,
  styles ,
  make ,
}
/* styles Not a pure module */
